const pageNameKey = "otaErrorBox";

export const otaErrorBoxEn = {
  [pageNameKey]: {
    titlePrefixFirmware:
      "Error Firmware Installation {itemName}{installationId}",
    titlePrefixBackup: "Error Backup Installation {itemName}{installationId}",
    installationIdTemplate: " (Installation ID {ID})",
  },
};

export const otaErrorBoxPtBr = {
  [pageNameKey]: {
    titlePrefixFirmware:
      "Erro na instalacao de firmware {itemName}{installationId}",
    titlePrefixBackup:
      "Erro na instalacao de backup {itemName}{installationId}",
    installationIdTemplate: " (ID da instalacao {ID})",
  },
};

export const otaErrorBoxDe = {
  [pageNameKey]: {
    titlePrefixFirmware:
      "Fehler bei der Firmware-Installation {itemName}{installationId}",
    titlePrefixBackup:
      "Fehler bei der Backup-Installation {itemName}{installationId}",
    installationIdTemplate: " (Installations-ID {ID})",
  },
};

export const otaErrorBoxZhHans = {
  [pageNameKey]: {
    titlePrefixFirmware: "固件安装错误 {itemName}{installationId}",
    titlePrefixBackup: "备份安装错误 {itemName}{installationId}",
    installationIdTemplate: "（安装 ID {ID}）",
  },
};

export const otaErrorBoxIt = {
  [pageNameKey]: {
    titlePrefixFirmware:
      "Errore installazione firmware {itemName}{installationId}",
    titlePrefixBackup: "Errore installazione backup {itemName}{installationId}",
    installationIdTemplate: " (ID installazione {ID})",
  },
};

export const otaErrorBoxEs = {
  [pageNameKey]: {
    titlePrefixFirmware:
      "Error en la instalacion de firmware {itemName}{installationId}",
    titlePrefixBackup:
      "Error en la instalacion de respaldo {itemName}{installationId}",
    installationIdTemplate: " (ID de instalacion {ID})",
  },
};

export const otaErrorBoxNl = {
  [pageNameKey]: {
    titlePrefixFirmware:
      "Fout bij firmware-installatie {itemName}{installationId}",
    titlePrefixBackup: "Fout bij back-upinstallatie {itemName}{installationId}",
    installationIdTemplate: " (Installatie-ID {ID})",
  },
};

export const otaErrorBoxTr = {
  [pageNameKey]: {
    titlePrefixFirmware: "Firmware Kurulumu Hatası {itemName}{installationId}",
    titlePrefixBackup: "Hata Yedekleme Kurulumu {itemName}{installationId}",
    installationIdTemplate: "(Kurulum Kimliği {ID})",
  },
};
